import React, { Component, PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

class YearOfManufacture extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorLevel: 'normal'
    }
  }

  componentWillMount() {

  }

  render() {
    return (
      <FormGroup controlId="yearOfManufacture">
        <Col componentClass={ControlLabel} sm={5}>
          {this.props.required ? 'Year Of Manufacture *' : 'Year Of Manufacture'}
        </Col>
        <Col sm={7}>
            <FormControl type="text"
              value={this.props.yearOfManufacture}
              onChange={this.props.handleChangeYearOfManufacture}
              onBlur={this.props.calculation}
              autoComplete="off"
              required={this.props.required}
            />
        </Col>

      </FormGroup>
    )
  }
}

YearOfManufacture.propTypes = {
  yearOfManufacture: PropTypes.string,
  handleChangeYearOfManufacture: PropTypes.func,
  calculation: PropTypes.func,
  required: PropTypes.bool
};

export default YearOfManufacture;



// WEBPACK FOOTER //
// ./src/app/components/quotationCVComponent/yearOfManufacture/YearOfManufacture.js